var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"certiface-verify"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.messages[0].text)}}),_vm._v(" "),_c('a',{staticClass:"donation-nav donation-nav--forward",attrs:{"href":_vm.messages[1].href}},[_vm._v(_vm._s(_vm.messages[1].text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2385b931","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./_source/javascript/components/steps/certFaceVerify.vue
// module id = 267
// module chunks = 0